import { Button, Dropdown, message, Modal, Spin, Tag } from "antd";
import "./BulkDownload.scss";
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Mixpanel } from "app/config/Mixpanel";

import {
  CarryOutOutlined,
  CheckOutlined,
  FormOutlined,
  HolderOutlined,
  CheckCircleFilled,
  LoadingOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { Select, Switch, Tree } from "antd";
import type { TreeDataNode } from "antd";
import { colorPicker } from "app/utils/color.helper";
import Typography from "../Typography";
import { Column } from "ag-grid-enterprise";
import { apiGet, apiPost, apiPostForm } from "app/services/apiServices";
import {
  API_ENDPOINT_AG_TABLE_RAISE_DOWNLOAD_INVOICE_REQUEST,
  API_ENDPOINT_AG_TABLE_RAISE_DOWNLOAD_INVOICE_REQUEST_HISTORY,
} from "../AgTable/AgTable.constants";
import { AgTableClient } from "../AgTable";
import moment from "moment";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import { defaultFileTagInvoiceMap } from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";
import Uploader from "../Uploader";
import { API_ENDPOINT_UPLOAD_FILE,API_ENDPOINT_FIELDNAME } from "./Bulk.constant";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import { serverModeState } from "app/config/States/users";
import { useRecoilValue } from 'recoil';

export default function BulkDownloadWidget(props: any) {
  const [showModal, setShowModal] = useState(false);
  const [showModalFor, setShowModalFor] = useState("");
  const [showLine, setShowLine] = useState<boolean>(true);
  const [showIcon, setShowIcon] = useState<boolean>(false);
  const [showLeafIcon, setShowLeafIcon] = useState<React.ReactNode>(true);
  const [filenameTags, setFileNameTags] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [history, setHistory] = useState<any[]>([]);
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [useServer, setUseServer] = useRecoilState(serverModeState)
  const [showUploaderModal, setShowUploaderModal] = useState(true);
  

  const [formData, setFormData] = useState<any>(null);
const [matchedHeaderName, setMatchedHeaderName] = useState("");
const [matchedFields, setMatchedFields] = useState([]);

  const onSelect = (selectedKeys: React.Key[], info: any) => {
  };

  const handleLeafIconChange = (value: "true" | "false" | "custom") => {
    if (value === "custom") {
      return setShowLeafIcon(<CheckOutlined />);
    }

    if (value === "true") {
      return setShowLeafIcon(true);
    }

    return setShowLeafIcon(false);
  };

  useEffect(() => {
    fetchDownloadHistory();
  }, [userDetails.currentWorkspace]);

  useEffect(() => {
    if (showModal && showModalFor === "DOWNLOAD") {
      FinkAnalytics("user_opened_download_invoice_modal", {
        event_category: "modal_open",
        event_label: "Download Invoice Modal Opened",
      });
    }
  }, [showModal, showModalFor]);

  

  const handleAddFileTag = (tag: string) => {
    setFileNameTags((prevKeys) => {
      if (prevKeys.includes(tag)) {
        // If key exists, remove it
        return prevKeys.filter((k) => k !== tag);
      } else {
        // If key doesn't exist, add it
        return [...prevKeys, tag];
      }
    });
  };

  function getFileExtension(fileName: string) {
    // Split the file name by the dot character
    let parts = fileName.split(".");

    // Get the last part of the array which should be the file extension
    let extension = parts[parts.length - 1];

    return extension;
  }

  //new ----
  // const handleUpload = async (file: any) => {
  //   try {
  //     setLoading(true);
  //     // Allowed file types
  //     const allowedTypes = ["text/csv"];
  //     const fileType = file.type;

  //     if (!allowedTypes.includes(fileType)) {
  //       messageApi.error("Only CSV (.csv) files are allowed.");
  //       setLoading(false);
  //       return;
  //     }
  //     let fileExtension = getFileExtension(file.name);
  //     let formData = new FormData();
  //     formData.append("file", file);
  //     formData.append(
  //       "filename",
  //       `${
  //         file.name || "invoice_download_file"
  //       }_${moment().unix()}.${fileExtension}`
  //     );

  //     console.log("FormData:", formData);

  //     const response = await apiPostForm(API_ENDPOINT_UPLOAD_FILE, formData);
  //     console.log(response.data);

  //     if (response.status) {
  //       const fileUrl = response.data.fileUrl;
  //       messageApi.success("File uploaded successfully.");
  //       handleRaiseDownloadRequest(fileUrl);
  //     }
  //   } catch (error) {
  //     messageApi.error("Error uploading file");
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  ///before

  // const handleUpload = async (file: any) => {
  //   try {
  //     setLoading(true);
  //     const allowedTypes = ["text/csv"];
  //     const fileType = file.type;

  //     // Check for valid file type
  //     if (!allowedTypes.includes(fileType)) {
  //       messageApi.error("Only CSV (.csv) files are allowed.");
  //       setLoading(false);
  //       return;
  //     }

  //     // Read the file content
  //     const text = await file.text();
  //     const lines = text.trim().split("\n");

  //     // Validate content: check if there's at least one valid invoice number after the header
  //     if (lines.length <= 1 || lines.slice(1).every((line: string) => line.trim() === "")) {
  //       messageApi.error("The uploaded file is empty or contains no invoice numbers.");
  //       setLoading(false);
  //       return;
  //     }

  //     let fileExtension = getFileExtension(file.name);
  //     let formData = new FormData();
  //     formData.append("file", file);
  //     formData.append(
  //       "filename",
  //       `${file.name || "invoice_download_file"}_${moment().unix()}.${fileExtension}`
  //     );

  //     console.log("FormData:", formData);

  //     // Send the file for upload
  //     const response = await apiPostForm(API_ENDPOINT_UPLOAD_FILE, formData);
  //     console.log(response.data);

  //     // Handle the response
  //     if (response.status) {
  //       const fileUrl = response.data.fileUrl;
  //       messageApi.success("File uploaded successfully.");
  //       handleRaiseDownloadRequest(fileUrl);
  //     }
  //   } catch (error) {
  //     messageApi.error("Error uploading file");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleUpload = async (file: any) => {
    try {
     
      const allowedTypes = ["text/csv"];
      const fileType = file.type;
      // Check for valid file type
      if (!allowedTypes.includes(fileType)) {
        messageApi.error("Only CSV (.csv) files are allowed.");
        setLoading(false);
        return;
      }

      // Read the file content
      const text = await file.text();
      const lines = text.trim().split("\n");
  
      // Validate content
      if (lines.length <= 1 || lines.slice(1).every((line: string) => line.trim() === "")) {
        messageApi.error("The uploaded file is empty or contains no invoice numbers.");
        setLoading(false);
        return;
      }
  
      // Extract headers
      const rawHeaderLine = lines[0];
      const headers = rawHeaderLine
        .split(",")
        .map((header: string) => header.trim().replace(/^"|"$/g, ""));
  
      const fileExtension = getFileExtension(file.name);
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "filename",
        `${
          file.name || "invoice_download_file"
        }_${moment().unix()}.${fileExtension}`
      );
      formData.append("headers", JSON.stringify(headers));
  
      const values = lines.slice(1).map((line: any) => {
        const row = line
          .split(",")
          .map((cell: any) => cell.trim().replace(/^"|"$/g, ""));
        return row;
      });
  
      const payload = {
        moduleId: props.moduleId,
        database: props.database || "airlines_db",
        tableName: props.tableName,
        fieldName: headers, // Fix: Don't call formData.append inside payload
        values: values
      };
      setLoading(true)

     
  
      const response = await fetch(API_ENDPOINT_FIELDNAME,{
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload),
      });
  
      const result = await response.json();
      const matchedHeaderName = String(Object.values(result?.fieldHeaderMap || {})[0]);
      const matchedFields = result?.matchedFields;
  
      if (!matchedHeaderName) {
        messageApi.warning("No matching field found in table.");
        return;
      }
  
      // ✅ Save values for controlled modal
      setMatchedHeaderName(matchedHeaderName);
      setMatchedFields(matchedFields);
      setFormData(formData);
  
      // ✅ Show confirmation modal
      setShowUploaderModal(false); // hide uploader if separate modal
      setShowModalFor("CONFIRM_UPLOAD");
      setShowModal(true);
    } catch (error) {
      messageApi.error("Error uploading file.");
    } finally {
      setLoading(false);
    }
  };
  




  const fetchDownloadHistory = async () => {
    const response = await apiGet(
      API_ENDPOINT_AG_TABLE_RAISE_DOWNLOAD_INVOICE_REQUEST_HISTORY
      // "http://localhost:7001/api/agtable/report/getinvoicedownloaddetails"
    );
    if (response.status) {
      setHistory(response.data);
    }
  };

  const createTree = (items: any) => {
    const makeNode: any = (title: string, key: any, children = []) => ({
      title,
      key,
      icon: <CarryOutOutlined />,
      children,
    });

    // If items array is empty, only show the two PDF children
    if (items.length === 0) {
      return [
        {
          title: "Invoices.zip",
          key: "0",
          icon: <CarryOutOutlined />,
          children: [
            {
              title: "invoice_1.pdf",
              key: "0-1",
              icon: <CarryOutOutlined />,
            },
            {
              title: "invoice_2.pdf",
              key: "0-2",
              icon: <CarryOutOutlined />,
            },
          ],
        },
      ];
    }

    // Start with the base node
    let tree = makeNode(items[0], "0-0");

    // Reference to the current node
    let currentNode = tree;

    // Iterate over the remaining items to build the tree
    for (let i = 1; i < items.length; i++) {
      const newNode = makeNode(items[i], `${currentNode.key}-${i - 1}`);
      currentNode.children = [newNode];
      currentNode = newNode;
    }

    // Add final children to the last node
    currentNode.children = [
      makeNode("invoice_1.pdf", `${currentNode.key}-0`),
      makeNode("invoice_2.pdf", `${currentNode.key}-1`),
    ];

    return [
      {
        title: "Invoices.zip",
        key: "0",
        icon: <CarryOutOutlined />,
        children: [tree],
      },
    ];
  };

  const handleRaiseDownloadRequest = async (fileUrl = null, matchedFields: string[] = []) => {
    const domain = getSubdomain();
    setLoading(true);

    let backupPayload = {
      startRow: 0,
      endRow: 100,
      rowGroupCols: [],
      valueCols: [],
      pivotCols: [],
      pivotMode: false,
      groupKeys: [],
      filterModel: {},
      sortModel: [],
    };

    const payload = {
      // filenameTags: defaultFileTagInvoiceMap[domain] || [],
      // filenameTags: props.invoiceNumberColumn || [],
      filenameTags: Array.isArray(props.invoiceNumberColumn)
      ? props.invoiceNumberColumn
      : props.invoiceNumberColumn
      ? [props.invoiceNumberColumn]
      : [],
      groupingPayload: props.getPayload() || backupPayload,
      moduleId: props.moduleId,
      columnLinks: ["assetlink"],
      dbType: props.dbType || "postgre",
      database: props.database || "airlines_db",
      tableName: props.tableName,
      requestlink: fileUrl,
      // columnInvoiceNo: [
      //   ...(defaultFileTagInvoiceMap[domain] || []),
      //   ...matchedFields
      // ],
      columnInvoiceNo: [
        ...[
          ...(props.invoiceNumberColumn || []),
          // ...other arrays
        ].filter((value, index, self) => self.indexOf(value) === index)
      ],
    };
    const response = await apiPost(
      API_ENDPOINT_AG_TABLE_RAISE_DOWNLOAD_INVOICE_REQUEST,
      // "http://localhost:7001/api/agtable/report/invoicedownload",
      payload
    );
    if (response.status) {
      messageApi.success({
        type: "success",
        content: response.message,
      });
      props.success();
      fetchDownloadHistory();
      setShowModal(false);
      setShowModalFor("");
    }
    setLoading(false);
  };

  let tablePayload;
  let tableColumns = [];
  let groupedColumns = [];

  try {
    tablePayload = props.getPayload?.() || {};
    tableColumns = props.getColumnDefs?.() || [];
    groupedColumns = (tablePayload?.rowGroupCols || []).map(
      (item: any) => item.field
    );
  } catch (error) {
    tablePayload = {};
    tableColumns = [];
    groupedColumns = [];
  }

  const onMenuClick = (e: any) => {
    setShowModalFor("HISTORY");
    setShowModal(true);
  };

  const getReportActionButton = (rowInfo: any) => {
    switch (rowInfo.status) {
      case "COMPLETED":
        return (
          <Button
            size="small"
            style={{ color: colorPicker("green.700") }}
            icon={<DownloadOutlined />}
            // onClick={() => {
            //   rowInfo?.filehash &&
            //     window.open(
            //       `https://files.finkraft.ai/invoice-${rowInfo?.filehash}`,
            //       "_blank"
            //     );
            // }}
            onClick={() => {
              if (rowInfo?.link) {
                window.open(rowInfo.link, "_blank");
              }
            }}
          >
            {rowInfo?.link ? "Download" : "No Data"}
          </Button>
        );

      case "PENDING":
        return (
          <Button
            size="small"
            style={{ color: colorPicker("yellow.700") }}
            icon={
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 12,
                      marginRight: 6,
                      color: colorPicker("yellow.700"),
                    }}
                    spin
                  />
                }
              />
            }
          >
            Generating
          </Button>
        );

      case "IN PROGRESS":
        return (
          <Button
            size="small"
            style={{ color: colorPicker("yellow.700") }}
            icon={
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 12,
                      marginRight: 6,
                      color: colorPicker("yellow.700"),
                    }}
                    spin
                  />
                }
              />
            }
          >
            Generating
          </Button>
        );

      case "EXCEPTION IN GETDATA":
        return (
          <Button size="small" style={{ color: colorPicker("red.700") }}>
            Failed, Regenerate
          </Button>
        );

      case "FAILED":
        return (
          <Button size="small" style={{ color: colorPicker("red.700") }}>
            Failed, Regenerate
          </Button>
        );
      case "NO RECORDS":
        return (
          <Button size="small" style={{ color: colorPicker("yellow.700") }}>
            No Record Found
          </Button>
        );
    }
  };

  const downloadSampleCredentialCSV = async () => {
    Mixpanel.track("Download Sample CSV", {
      Screen: "Workspace",
    });

    // Define only Invoice Numbers in CSV
    let csvString = `Invoice Number
  I270000014319179
  I270000014319180
  I270000014319181
  I270000014319182`;

    try {
      // Convert the CSV string to a Blob
      const csvBlob = new Blob([csvString], { type: "text/csv" });

      // Convert the Blob object to a data URL
      const csvDataUrl = URL.createObjectURL(csvBlob);

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = csvDataUrl;
      link.setAttribute("download", "invoice_numbers.csv");

      // Trigger the download by programmatically clicking the anchor element
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
    } catch (error) {
    }
  };

  return (
    <div className="BulkDownload">
      <Dropdown.Button
        size="small"
        type="primary"
        menu={{
          items: [
            {
              key: "1",
              label: "Download History",
            },
          ],
          onClick: onMenuClick,
        }}
        onClick={() => {
          // setUseServer(true);
          setShowModalFor("DOWNLOAD");
          setShowModal(true);
          // if (userDetails?.hasInvoiceRequestRaised) {
          //   let workspaceInfo = (userDetails?.workspaces || []).find(
          //     (item: any) =>
          //       item.id ===
          //       userDetails?.hasInvoiceRequestRaised?.workspace_id?.[0]
          //   );
          //   message.info(
          //     `Invoice generation is already in progress ${
          //       workspaceInfo ? `for ${workspaceInfo?.name} ` : ""
          //     }, please wait for it to complete`
          //   );
          // } else {
          //   setShowModalFor("DOWNLOAD");
          //   setShowModal(true);
          // }
        }}
      >
        {props.type && props.type === "CSV"
          ? "Upload Invoices Using Invoice Number"
          : "Download Invoices"}
      </Dropdown.Button>

    





      {/* HISTORY Modal */}
{showModalFor === "HISTORY" && (
  <Modal
    footer={false}
    title="Bulk Download History"
    open={showModal}
    className="custom-modalBulk"
    onCancel={() => {
      setShowModal(false);
      setShowModalFor("");
    }}
  >
    <div style={{ height: 400 }}>
      <AgTableClient
          // @ts-ignore
        rowData={history}
        columnDefs={[
          {
            field: "report_name",
            headerName: "Report Name",
            filter: "agTextColumnFilter",
            cellRenderer: (params: any) => {
              const createdAt = params.data?.createdAt;
              let dateObj;
              if (!createdAt) return "Invoice Report";

              if (!isNaN(createdAt)) {
                dateObj = new Date(Number(createdAt));
              } else if (typeof createdAt === "string" && createdAt.includes("-")) {
                const [dd, mm, yyyy] = createdAt.split("-");
                dateObj = new Date(`${yyyy}-${mm}-${dd}`);
              }

              if (!dateObj || isNaN(dateObj.getTime())) return "Invoice Report";

              return `Invoice Report ${moment(dateObj).format("DD MMM")}`;
            },
          },
          {
            field: "createdAt",
            headerName: "Created At",
            cellRenderer: (params: any) => {
              const value = params.data?.createdAt;
              if (!value) return "";

              if (typeof value === "string" && value.match(/^\d{2}-\d{2}-\d{4}$/)) {
                return value;
              }
              return moment(value).fromNow();
            },
          },
          {
            field: "status",
            headerName: "Status",
            cellRenderer: (params: any) => getReportActionButton(params?.data),
          },
          {
            headerName: "Expiry Time",
            field: "expiry_at",
            cellRenderer: (params: any) => {
              if (!params.value) return "";

              const expiryDate = new Date(params.value);
              const now = new Date();

              let diffMs = expiryDate.getTime() - now.getTime();

              if (diffMs <= 0) return <span style={{ color: "red" }}>Expired</span>;

              const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
              diffMs -= diffDays * (1000 * 60 * 60 * 24);

              const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
              const text = `${diffDays} days ${diffHours} hrs`;

              return <span style={{ color: "red" }}>{text}</span>;
            },
          },
        ]}
        hideToolbar
      />
    </div>
  </Modal>
)}

{/* Other Modals */}
{showModalFor !== "HISTORY" && (
  <Modal
    footer={false}
    title={showModalFor === "CONFIRM_UPLOAD" ? "Confirm Upload" : props.type === "CSV" ? "Bulk Downloader" : "Downloader"}
    open={showModal}
    onCancel={() => {
      setShowModal(false);
      setShowModalFor("");
    }}
  >
    {showModalFor === "CONFIRM_UPLOAD" ? (
      <div>
        <Typography>
          Hey, do you want to continue downloading with "<strong>{matchedHeaderName}</strong>"?
        </Typography>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24, gap: 8 }}>
          <Button
            onClick={() => {
              messageApi.info("Download cancelled.");
              setShowModalFor("CSV"); // return to previous modal content
            }}
          >
            No
          </Button>
          <Button
            type="primary"
            loading={isLoading}
            onClick={async () => {
              try {
                setLoading(true);

                FinkAnalytics("user_clicked_upload_invoice_cta", {
                  event_category: "cta_click",
                  event_label: "Confirmed Upload Invoice",
                  workspace_name: userDetails.currentWorkspace?.name,
                  subdomain: window.location.hostname.split(".")[0],
                });

                messageApi.success(`Proceeding with "${matchedHeaderName}"`);
                const response = await apiPostForm(API_ENDPOINT_UPLOAD_FILE, formData);

                if (response.status) {
                  const fileUrl = response.data.fileUrl;
                  handleRaiseDownloadRequest(fileUrl, matchedFields);
                  setShowModal(false);
                  setShowModalFor("");
                } else {
                  messageApi.error("File upload failed.");
                }
              } catch (err) {
                messageApi.error("Error uploading file.");
              } finally {
                setLoading(false);
              }
            }}
          >
            Yes
          </Button>
        </div>
      </div>
    ) : props.type === "CSV" ? (
      <Spin spinning={isLoading}>
        <div>
          <div
            onClick={() => {
              FinkAnalytics("user_clicked_download_sample_csv", {
                event_category: "button_click",
                event_label: "Download Sample CSV Clicked",
              });
              downloadSampleCredentialCSV();
            }}
            style={{
              fontSize: "14px",
              border: "1px solid #0a8394",
              borderRadius: "5px",
              width: "180px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: "8px",
              backgroundColor: "white",
              color: "#0a8394",
              marginLeft: "auto",
            }}
          >
            <DownloadOutlined style={{ marginRight: "4px", color: "#0a8394" }} />
            Download Sample CSV
          </div>
          <Uploader
            onSelect={(file: any, request_link: string) => {
              handleUpload(file);
            }}
          />
        </div>
      </Spin>
    ) : (
      <div>
        <div
          style={{
            background: "#0A839440",
            width: "100%",
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            style={{
              color: colorPicker("primary.700"),
              paddingLeft: 12,
              paddingRight: 12,
            }}
            variant="caption"
          >
            The download process will take upto 30 minutes depending upon size of file. You will be notified via email with the invoice zip.
          </Typography>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", marginTop: 24 }}>
          <Button size="small" style={{ marginRight: 12 }} onClick={() => setShowModal(false)} loading={isLoading}>
            Cancel
          </Button>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              FinkAnalytics("user_clicked_on_initiate_download_for_download_invoice", {
                event_category: "button_click",
                event_label: "Initiated Invoice Download",
                user_id: userDetails.id,
                user_identifier: userDetails.id || userDetails.email.split("@")[0],
                user_name: userDetails.name,
                user_email: userDetails.email,
                access_time: new Date().toISOString(),
              });
              handleRaiseDownloadRequest(null);
            }}
            loading={isLoading}
          >
            Initiate Download
          </Button>
        </div>
      </div>
    )}
  </Modal>
)}

      {contextHolder}
    </div>
  );
}
